export default __webpack_public_path__ + "static/media/06.fb31db9a.jpg";